const mapSettings = document.getElementById('viewport-map-settings');
let settings;
let homeTypesMapping;
if (mapSettings?.dataset?.settings !== '{}') {
    settings = JSON.parse(mapSettings?.dataset?.settings);
    settings = { ...settings,
        communityId: mapSettings?.dataset?.communityId,
        brand: mapSettings?.dataset?.brand
    };
}
else {
    settings = {};
}
if (mapSettings?.dataset.homeTypes && mapSettings.dataset.homeTypes !== '{}') {
    homeTypesMapping = JSON.parse(mapSettings.dataset.homeTypes);
}
else {
    homeTypesMapping = {};
}
const mapApiKey = mapSettings?.dataset?.mapKey ?? '';
const staticMapApiKey = mapSettings?.dataset?.staticMapKey;
const mapId = mapSettings?.dataset?.mapId;
const mortgageCalcEnabled = mapSettings?.dataset?.calcEnabled ? JSON.parse(mapSettings.dataset.calcEnabled.toLocaleLowerCase()) : false;
const isBlock = mapSettings?.dataset?.isBlock ? JSON.parse(mapSettings?.dataset?.isBlock.toLowerCase()) : false;
export { mapApiKey, staticMapApiKey, mapId, homeTypesMapping, mortgageCalcEnabled, isBlock };
export default settings;
